export const requestLogin = _ref => {
  let {
    wixCodeApi
  } = _ref;
  return async lang => {
    return wixCodeApi.user.promptLogin({
      lang
    }).catch(() => {});
  };
};
export const requestLogout = _ref2 => {
  let {
    wixCodeApi
  } = _ref2;
  return async () => {
    return wixCodeApi.user.logout();
  };
};
//# sourceMappingURL=user-actions.js.map